import { Box, Flex, Text, Spinner } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import QuickbookButton from 'assets/images/QuickBook_Button/C2QB_green_btn_med_default.svg?react';
import QuickbookButtonHovered from 'assets/images/QuickBook_Button/C2QB_green_btn_med_hover.svg?react';
import { AnimatedMascot } from 'components/Mascot';
import QuickbookOnlineSettings from 'containers/Integrations/Quickbook/Settings';
import { useFetchQuickbookAuthCode } from 'hooks/integrations/useFetchAuthCodeQuickbook';
import { useSaveQuickbookAuthCode } from 'hooks/integrations/useSaveQuickbookAuthCode';
import { useIntegrationStore } from 'store/useIntegrationStore';

const Configuration = () => {
  const { t } = useTranslation(['integrations']);

  const [isHovered, setIsHovered] = useState(false);

  const { data: qbOauthUrlData, status: qbOauthUrlStatus } = useFetchQuickbookAuthCode();
  const { status: qbAuthSaveStatus, mutate: qbAuthSaveMutate } = useSaveQuickbookAuthCode();

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const quickbookIntegrationData = integrationListData.filter((tab: any) => tab.key === 'quick-books-online')[0];

  const getCode = (e: any) => {
    const originUrl = e.origin + '/';
    if (originUrl === import.meta.env.VITE_CURRENT_URL) {
      window.removeEventListener('message', getCode);
      qbAuthSaveMutate(e.data);
    }
  };

  const onEnable = () => {
    if (qbOauthUrlStatus === 'success') {
      window.open(qbOauthUrlData.payload, 'Quickbook login', 'width=600, height=420');
      window.addEventListener('message', getCode);
    }
  };

  return (
    <>
      {!quickbookIntegrationData.is_connected ? (
        <Flex flexDirection="column">
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            mb={6}
          >
            <AnimatedMascot type="barking" />
            <Text>{t('integrations:quickbooks.clickOnConnectToQuickbooksToStart')}</Text>
          </Box>
          <button
            style={{ marginLeft: 'auto', position: 'relative' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onEnable}
            disabled={qbAuthSaveStatus === 'loading'}
          >
            {/* Must use QuickBook provided image as Button as to comply with QuickBook rules.
            https://developer.intuit.com/app/developer/qbo/docs/go-live/list-on-the-app-store/naming-and-logo-guidelines*/}
            {isHovered ? <QuickbookButtonHovered /> : <QuickbookButton />}
            {qbAuthSaveStatus === 'loading' && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                as="span"
                position="absolute"
                width="100%"
                height="100%"
                top="0"
                left="0"
                background="#2CA01C"
              >
                <Spinner size="sm" emptyColor="gray.200" color="success.500" thickness="3px" />
              </Box>
            )}
          </button>
        </Flex>
      ) : (
        <QuickbookOnlineSettings />
      )}
    </>
  );
};
export default Configuration;
